import { Pagination } from "antd";
import React, { useEffect, useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAppointmentHistory,
  fetchSelectedAppointmentDetails,
} from "../../actions/AppointmentActions";
import CustomeModal from "../CustomeModal/CustomeModal";
import "./appointmenthistory.css";
import AppointmentHistoryModalContent from "./AppointmentHistoryModalContent/AppointmentHistoryModalContent";

function AppoinmentHistory({ white }) {
  let [modal, setModal] = useState(false);
  let [totalnoofpages, setTotalnoofpages] = useState(0);
  let [loader, setLoader] = useState(true);
  let [activePage, setActivePage] = useState(1);
  let dummyData = [];
  let dispatch = useDispatch();

  let appointmentHistoryRedux = useSelector(
    (state) => state.appointmentHistory.appointmentHistory
  );
  let selectedAppointmentHistoryRedux = useSelector(
    (state) => state.appointmentHistory.appointmentHistory
  );

  const userDatas = useSelector((state) => state.login.user);

  const userData = JSON.parse(localStorage.getItem("userData"));

  const patientData = useSelector((state) => state.login.patientDashboard);

  let handleTableClick = (appointmentId) => {
    // dispatch(setModalRedux({
    //     name: "ApointmentHistoryModal",
    //     value: true
    // }))
    dispatch(
      fetchSelectedAppointmentDetails({
        appointmentId: appointmentId ? appointmentId : null,
        userData,
      })
    );

    setModal(true);
  };

  useEffect(() => {
    console.log("Calling appointment history...........");
    dispatch(fetchAppointmentHistory(userData, 0)).then((res) => {
      console.log("**************fetchAppointmentHistory API result ==> ", res);
      setLoader(false);
      if (res.data.data.totalNumberOfPages != undefined) {
        //   totalnoofpages=res.data.data.totalNumberOfPages;
        setTotalnoofpages(res.data.data.totalNumberOfPages);
      }
    });
  }, []);

  let getDateFull = () => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    let today = new Date();

    let date = today.getDate();
    let month = today.getMonth();
    let year = today.getFullYear();
    let week = today.getDay();

    return `${date}, ${months[month]}, ${year} - ${days[week]}`;
  };
  let handlePaginationChange = (e) => {
    setActivePage(e);
    // setLoader(true)
    dispatch(fetchAppointmentHistory(userData, e - 1)).then((res) => {
      console.log("**************fetchAppointmentHistory API result ==> ", res);
      // setLoader(false)
    });
  };

  return (
    <>
      <div
        className={`appontment-history-container ${
          white ? "appontment-history-container-white" : ""
        }`}
      >
        {!loader ? (
          appointmentHistoryRedux?.length > 0 ? (
            <div className="appoinment-table-wrap">
              <table className="appoinment-table">
                <tr>
                  <th>Appointment ID</th>
                  <th>Time</th>
                  <th>Doctor Name</th>
                  <th>Consultation Status</th>
                  {/* <th>Next Steps</th> */}
                  <th></th>
                </tr>

                <tbody>
                  {appointmentHistoryRedux?.length > 0 ? (
                    appointmentHistoryRedux.map((element, key) => {
                      return (
                        <tr>
                          <td>{element.appointmentId}</td>
                          <td>{element.appointmentDate}</td>
                          <td>{element.consultantName}</td>
                          <td>{element.appointmentStatus}</td>
                          {/* <td>
                            {element.nextstep != "Not provided"
                              ? "Follow up after " + element.nextstep
                              : element.nextstep}
                          </td> */}
                          <td>
                            <button
                              onClick={() => {
                                handleTableClick(element.appointmentId);
                              }}
                              className="more-btn"
                            >
                              More
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <div className="no-appointments">
                      Oops!! There is no appointments available for you.
                    </div>
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="no-appointments">
              Oops!! There is no appointments available for you.
            </div>
          )
        ) : (
          <div className="loader">
            <Spinner
              style={{ width: "4rem", height: "4rem", marginBottom: "15px" }}
              animation="border"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </Spinner>
            <div>Please Wait...</div>
          </div>
        )}

        {appointmentHistoryRedux?.length > 0 && totalnoofpages > 1 && (
          <div className="pagination-container" text={totalnoofpages}>
            <Pagination
              showSizeChanger={false}
              onChange={handlePaginationChange}
              defaultCurrent={activePage}
              total={totalnoofpages * 10}
            />
          </div>
        )}
      </div>

      <CustomeModal
        state={modal}
        setModal={setModal}
        component={<AppointmentHistoryModalContent />}
        isRight
      />
    </>
  );
}

export default AppoinmentHistory;
